<template>
  <div class="sd-thematic-tree" :class="{'fade-away-left':!isShow_}">
    <div class="panel-title">专题图</div>
    <div class="thematic-box">
      <div v-for="(schem,index) in list_" :key="index" class="thematic-item" :class="{'item_selected':selectSchem_ && selectSchem_.id===schem.id}" @click="handleSelectSchem(schem)">
        <span>{{ schem.programName }}</span>
      </div>
    </div>
    <slot name="switch">
      <div class="default-switch clickable">
        <div class="switch-item clickable" @click="isShow_=!isShow_" style="z-index:1">
          专题图
        </div>
      </div> 
    </slot>
  </div>
</template>

<script>
import {  getAllTree } from "@/api/layer.js"

export default {
  name: 'SdThematicTree',
  data() {
    return {
      list_:[],
      isShow_:true,
      selectSchem_:null
    };
  },
  
  mounted() {
    this.getList()
  },

  methods: {
    handleSelectSchem(item){
      this.selectSchem_ = item
      this.$emit('thematic-change',item)
    },
    getList(){
      getAllTree().then(res=>{
        this.list_ = res.data.data
        if (!this.selectSchem_ && this.list_.length) {
          this.handleSelectSchem(this.list_[0])
        }
      })
    }
  },
};
</script>

<style scoped>
.sd-thematic-tree{
  position: absolute;
  top: 0;
  left: 0;
  width: 400px;
  height: 100%;
  background: #fff;
  transition: left .3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  user-select: none;
  z-index: 10;
}
.fade-away-left{
  left:-400px;
}
.panel-title{
  font-size: 25px;
  font-weight: bold;
  padding: 5px 0 10px 0;
  margin: 10px 5px ;
  border-bottom: 2px solid rgb(211, 209, 209);
}
.default-switch{
  position: absolute;
  top:40%;
  right:0px;
 
}
.switch-item{
  width: 20px;
  word-break:break-all;       
  word-wrap:break-word;    
  padding:15px 5px;
  background-color: white;
  border-radius: 0 5px 5px 0; 
  position: absolute;
  opacity: 1;
  border-left: none;
  box-shadow: 5px 0 5px 0px #7e7d7d87;
}
.thematic-box{
  overflow-y: auto;
  height: calc(100% - 75px);
}
.thematic-item{
  text-align: left;
  font-size: 16px;
  margin: 5px 10px;
  padding: 7px 15px;
  border:1px solid rgb(223, 223, 223);
  border-radius: 5px;
  position: relative;
}
.thematic-item:hover{
  border-color: #409eff;
}
::-webkit-scrollbar{
  display: none;
}

.item_selected{
  border-color: #409eff;
}
.item_selected::after{
  content: '\2713';
  display: block;
  font-size: 15px;
  line-height: 12px;
  text-align: right;
  color: white;
  background: linear-gradient(45deg, transparent , transparent  50%, #409eff 50%, #409eff 100%);
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0px;
  top: 0px;
}
</style>